import React from 'react';
import { BanknoteIcon, BellRingIcon, ShieldCheckIcon } from 'lucide-react';
import { solutions } from '../../data/landingContent';
const icons = [BellRingIcon, ShieldCheckIcon, BanknoteIcon];
export function SolutionsSection() {
  return <section id="solutions" className="scroll-mt-6 bg-white" data-id="element-124" data-mp="1n25dlz11hfex">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-24" data-id="element-125" data-mp="1ryvweu48ap41">
        <div className="max-w-2xl" data-id="element-126" data-mp="2fp9oulqq6pz5">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-127" data-mp="2fqb1gune3kiz">
            How can we help you overcome these challenges?
          </p>
          <h2 className="mt-3 text-3xl font-bold tracking-[-0.035em] sm:text-4xl" data-id="element-128" data-mp="25r29u8fzyhzs">
            Credit Manager is powered by the Satago platform.
          </h2>
          <p className="mt-5 text-base leading-7 text-[#3A3A3A]" data-id="element-129" data-mp="2aolpncscf2tu">
            This powerful suite of credit management and credit control tools
            enables SMEs to adopt the very latest technology and workflow
            automation — making them more efficient at getting paid on time and
            freeing up staff to concentrate on more profitable work. Once the
            system is set up, your involvement can be minimal.
          </p>
          <p className="mt-4 text-base leading-7 text-[#3A3A3A]" data-id="element-130" data-mp="3e5l3eklpcann">
            The feedback we hear most from prospective clients is{' '}
            <span className="font-bold text-[#041F60]" data-id="element-131" data-mp="39603o7ypjy9v">how simple it is</span>{' '}
            and{' '}
            <span className="font-bold text-[#041F60]" data-id="element-132" data-mp="3n4zu9l5s6n8o">
              how inexpensive it is
            </span>
            . The solution was designed to tick both of those boxes.
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-133" data-mp="q6qa1zob2x1">
          {solutions.map((solution, index) => {
          const Icon = icons[index] || BellRingIcon;
          return <article key={solution.title} className="flex flex-col rounded-xl border border-[#A6B6F8]/50 bg-white p-6" data-id="element-134" data-mp="apxifx0rh5ty" data-mpi={index}>
                <span className="grid h-11 w-11 place-items-center rounded-lg bg-[#4BE4FF] text-[#041F60]" data-id="element-135" data-mp="ctrfy6km0p2d">
                  <Icon size={21} aria-hidden="true" data-id="element-136" data-mp="hrkkkv69lb0j" />
                </span>
                <p className="mt-5 text-xs font-bold uppercase tracking-[0.14em] text-[#5B5299]" data-id="element-137" data-mp="mrp4kv6dsnvi">
                  {solution.eyebrow}
                </p>
                <h3 className="mt-2 text-xl font-bold tracking-tight" data-id="element-138" data-mp="rjglsf3ndh8z">
                  {solution.title}
                </h3>
                <p className="mt-3 text-sm leading-6 text-stone-600" data-id="element-139" data-mp="10itx7dbc0fwc">
                  {solution.description}
                </p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}